import type { IApplicationDetails } from '@/features/ApplicationForm/types';
import Disclosure from './Disclosure';
import ProjectBudget from './ProjectBudget';
import ProjectDetails from './ProjectDetails';

export const MDGSApplicationDetails = ({ applicationData, files }: IApplicationDetails) => {
  return (
    <>
      <ProjectDetails step1={applicationData.step1} />
      <ProjectBudget step2={applicationData.step2} />
      <Disclosure step5={applicationData.step5} />
    </>
  );
};
